module.exports = __webpack_public_path__ + "img/day-states.938fd566.svg";